import { render, staticRenderFns } from "./Enter.vue?vue&type=template&id=2bf0a800&scoped=true&"
import script from "./Enter.vue?vue&type=script&lang=js&"
export * from "./Enter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0a800",
  null
  
)

export default component.exports